export default __webpack_public_path__ + "static/media/GR.8fb75d94.svg";